import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { GeneralService } from "../../../services/GeneralService";
import { PreCandidateService } from "../../../services/PreCandidate";
import { usePrecandidateContext } from "../context/Context";

const ModalSelectDNALanguage = () => {
  const {
    showModalSelectDNALanguage,
    setShowSelectDNALanguage,
    preCandidateId,
    setShowModalDNASentSuccessfully
  } = usePrecandidateContext();

  const { t } = useTranslation();
  const [languages, setLanguages] = useState([{}]);
  const [languageSelected, setLanguageSelected] = useState(0);

  useEffect(() => {
    GeneralService.getVitaeLanguages().then(function (data) {
      data.forEach((element) => {
        if (element.initials === "EN") {
          setLanguageSelected(Number(element.id));
        }
      });
      setLanguages(data);
    });
  }, [showModalSelectDNALanguage]);

  function onChangeLanguage({ target }) {
    setLanguageSelected(Number(target.value));
  }

  function sendDocOnline() {
    (async () => {
      setShowSelectDNALanguage(false);
      let result = await PreCandidateService.SendDNA({
        preCandidateId: preCandidateId,
        generatedLanguageId: languageSelected
      });
      if (result === undefined) {
        setShowModalDNASentSuccessfully(true);
      }
    })();
  }

  return (
    <ModalContainer
      modalTitle={t("Choose a language")}
      isOpen={showModalSelectDNALanguage}
      submitButtonAction={() => {
        sendDocOnline();
      }}
      submitButtonTitle={t("Send")}
      submitButtonType="submit"
      closeModal={() => setShowSelectDNALanguage(false)}
      crossmarkAction={() => setShowSelectDNALanguage(false)}
    >
      <div className="mb-3">
        {t("What language should the Doc Online be generated ?")}
      </div>

      <div className="col-md-4">
        <div className="form-group">
          <select
            id="languageId"
            name="languageId"
            className="form-select"
            onChange={onChangeLanguage}
            value={languageSelected}
          >
            {languages.map((item) => (
              <option key={item.id} value={item.id}>
                {t(item.languageDescription)}
              </option>
            ))}
          </select>
        </div>
      </div>
    </ModalContainer>
  );
};

export default ModalSelectDNALanguage;
